__turbopack_context__.v({
  "className": "Es97ma_className",
  "variable": "Es97ma_variable",
});
